import React, { Component } from 'react';
import Logo from '../../Resources/Images/header-logo.svg';
import MenuIcon from '../../Resources/Images/menu-search.svg';
import MenuIconActive from '../../Resources/Images/menu-search-blue.svg';
import UserIcon from '../../Resources/Images/user.svg'
import UserIconActive from '../../Resources/Images/user-blue.svg'
import Info from '../../Resources/Images/info.svg'
import InfoActive from '../../Resources/Images/info-blue.svg'
import './Header.css';


class Header extends Component {
    constructor(props) {
        super(props);

        this.state = {
            user: props.user
        };
        this.handleProfileButtonClick = this.handleProfileButtonClick.bind(this);
        this.handleMenuButtonClick = this.handleMenuButtonClick.bind(this);
        this.goHistoryBack = this.goHistoryBack.bind(this);
    }
    handleProfileButtonClick() {
        this.props.resetSearch();
        this.props.changeRoute('profile');

    }

    handleMenuButtonClick() {
        this.props.resetSearch();
        this.props.changeRoute('menu');
        this.props.setCategory(1);
    }

    toHome(e) {
        e.preventDefault();
        this.props.changeRoute('');
    }

    toInfo(e) {
        e.preventDefault();
        this.props.changeRoute('info');
    }

    goHistoryBack(e) {
        e.preventDefault();
        window.history.back();
    }

    render() {
        if(this.props.loggedIn) {
            var profileClass = 'no-select';
            var profileIcon = <img src={UserIcon} height="36" alt="profile" />;
            var menuClass = 'no-select';
            var menuIcon = <img src={MenuIcon} height="36" alt="menu" />;
            var infoClass = 'no-select';
            var infoIcon = <img src={Info} className="info-image" height="36" alt="info" title="Info" />
            if(this.props.route === 'menu' || this.props.route === '') {
                menuClass = 'active no-select';
                menuIcon = <img src={MenuIconActive} height="36" alt="menu" />
            }else if(this.props.route === 'profile') {
                profileIcon = <img src={UserIconActive} height="36" alt="profile" />
                profileClass = 'active no-select';
            }else if(this.props.route === 'info') {
                    infoClass = 'active no-select';
                    infoIcon = <img src={InfoActive} height="36" className="info-image" alt="info" title="Info" />
            }
            return (
                <header id="header">
                    <div className="logo">
                        <a className="no-select" onClick={(event) => this.toHome(event)} href="">
                            <img src={Logo} className="App-logo" alt="logo"/>
                        </a>
                    </div>
                    <div className="info">
                        <a onClick={(event) => this.toInfo(event)} href="" className={infoClass}>
                            {infoIcon}
                        </a>
                    </div>
                    <div className="history-back">
                        <button className="no-select" onClick={(event) => this.goHistoryBack(event)}>
                           Zurück
                        </button>
                    </div>
                    <div className="menu">
                        <button type="button" className={menuClass} onClick={this.handleMenuButtonClick}>
                            {menuIcon}
                        </button>
                    </div>
                    <div className="profile">
                        <button type="button" className={profileClass} onClick={this.handleProfileButtonClick}>
                            {profileIcon}
                        </button>
                    </div>
                </header>
            )
        }else{
            return <header id="header"></header>
        }

    }
}

export default Header;


// WEBPACK FOOTER //
// ./src/Components/Header/Header.js